export enum DisplaySummarizedStatusEnum {
  Unknown = -99,
  FailedCleansing = -10,
  FailedSystemConfiguration = -2,
  FailedNetworkConfiguration = -1,
  NotConfigured = 0,
  NetworkConfigured = 1,
  FailedCommunication = 2,
  LowBattery = 3,
  CurrentPageDesignNotFound = 4,
  CurrentPageProductNotFound = 5,
  CurrentPageFailedUpdate = 6,
  AlternatePageDesignNotFound = 7,
  AlternatePageProductNotFound = 8,
  AlternatePageFailedUpdate = 9,
  Okay = 10,
  FailedHealthCheck = 11,
  LowTemperature = 12,
  ImageOverwritten = 20,
  AddonFailed = 21,
  Preconfigured = 50,
  Queued = 99,
}

// Single source of truth for which summarized-status values count as a "failure".
// The DisplayList "FAILED" filter set (filter-set-static.data.ts) and the failed
// markers/colouring across the UI all derive from this list — keep them in sync by
// referencing it rather than re-listing the numbers.
export const DISPLAY_FAILED_STATUS_VALUES: readonly number[] = [
  DisplaySummarizedStatusEnum.Unknown,
  DisplaySummarizedStatusEnum.FailedCleansing,
  DisplaySummarizedStatusEnum.FailedSystemConfiguration,
  DisplaySummarizedStatusEnum.FailedNetworkConfiguration,
  DisplaySummarizedStatusEnum.FailedCommunication,
  DisplaySummarizedStatusEnum.CurrentPageDesignNotFound,
  DisplaySummarizedStatusEnum.CurrentPageProductNotFound,
  DisplaySummarizedStatusEnum.CurrentPageFailedUpdate,
  DisplaySummarizedStatusEnum.AlternatePageDesignNotFound,
  DisplaySummarizedStatusEnum.AlternatePageProductNotFound,
  DisplaySummarizedStatusEnum.AlternatePageFailedUpdate,
  DisplaySummarizedStatusEnum.AddonFailed,
  52, // Unregistered — no enum member, but part of the failed filter set
];

const FAILED_STATUS_SET = new Set<number>(DISPLAY_FAILED_STATUS_VALUES);

export function isDisplayFailedStatus(value: number | null | undefined): boolean {
  return value != null && FAILED_STATUS_SET.has(value);
}
